import styled from "styled-components"

import { Typography, type Variant, } from "@bracket/ui";
import { isWEIString, type WEIString, } from "@bracket/types";
import { useCallback, } from "react";

import type { FunctionComponent, } from "react"


const { error, } = console;


//@ts-ignore - remove if props added
export declare type DollarAmountProps = {
	value: WEIString;
	variant?: Variant;
};


export const DollarAmount: FunctionComponent<DollarAmountProps> = ({
	value,
	variant = "p"
}) => {

	const validValue = useCallback(() => isWEIString(value), [value]);

	const formatted = () => {
		if(!validValue){ 
			error("DollarAmount:: value argued is not WEI");
			return "invalid";
		}
		const valnum = Number(value) / 1e18;
		return valnum.toLocaleString("en-US", { style: "currency", currency: "USD", });
	}

	return (
		<Brace>
			<Typography variant={variant}>{formatted()}</Typography>
		</Brace>
	);

}


const Brace = styled.div`

`
